import { connect } from 'react-redux';

import HeaderTop from '../../../../../../components/Templates/A/Header/components/HeaderTop';

const mapStateToProps = ({ app }) => ({
  blog: app.getIn(['config', 'showComponents', 'blog']),
  stores: app.getIn(['config', 'showComponents', 'lojas'], true),
  top: app.getIn(['header', 'top'], ''),
});

export default connect(mapStateToProps)(HeaderTop);
